import { ViewCell, ViewConfig } from "@lib/views";
import { LimitCell } from "../cells/LimitCell";
import { ReceiptSenderActionsCell } from "../cells/ReceiptSenderActionsCell";
import { PhoneNumberCell } from "../cells/PhoneNumberCell";

export enum PhoneNumberSenderColumn {
    PHONE_NUMBER = "phoneNumber",
    LIMIT = "limit",
    ACTIONS = "actions",
}

export interface PhoneNumberSenderRow {
    id: string;
    phoneNumber: string | null;
    limit: number;
    workspaceId: string;
    createdAt: Date;
    updatedAt: Date;
}

export const phoneNumberSendersViewConfig: ViewConfig<
    PhoneNumberSenderRow,
    PhoneNumberSenderColumn,
    never
> = {
    columns: {
        [PhoneNumberSenderColumn.PHONE_NUMBER]: {
            accessorKey: "phoneNumber",
            name: "Phone Number",
            header: "Phone Number",
            cell: PhoneNumberCell,
            minSize: 200,
            maxSize: 1000,
        },
        [PhoneNumberSenderColumn.LIMIT]: {
            accessorKey: "limit",
            name: "Limit",
            header: "Limit",
            cell: LimitCell,
            minSize: 100,
            maxSize: 150,
        },
        [PhoneNumberSenderColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: ReceiptSenderActionsCell as unknown as ViewCell<
                PhoneNumberSenderRow,
                string
            >,
            minSize: 60,
            maxSize: 60,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
